<div class="flex justify-between items-center py-3 px-5">
    <!-- Split data between 2 columns -->
    <div class="flex flex-col justify-between h-full">
        <!-- Split first col into 2 rows, first one has icon and title -->
        <div class="flex items-center mb-2">
            <mat-icon [svgIcon]="icon" class="mr-2 text-[13px]" [style.color]=mainColor></mat-icon>
            <h3 class="leading-5 text-gray-500">{{ title | transloco }}</h3>
        </div>

        <!-- Second line has number and total -->
        <p class="text-7xl font-bold text-gray-700 ml-1">
            {{ value }}<span class="text-xl text-gray-700">/ {{ total }}</span>
        </p>
    </div>

    <!-- Second column has the donut chart -->
    <div class="relative flex items-center justify-center">
        <app-donut-chart [width]="130" [height]="130" [data]="[value, total]" [colors]="colors"></app-donut-chart>
    </div>
</div>
